<template>
  <tr>
    <td>
      <table>
        <tr>
          <td>
            <font style="text-align: left; font-weight: bold; font-size: 20px; color: #000000;">
              {{ item.product.lounge_name }}
            </font>
          </td>
        </tr>
        <tr>
          <td height="5" style="line-height:5px; font-size:0px;">&nbsp;</td>
        </tr>
        <tr>
          <td>
            <font style="font-weight: normal; font-size: 14px; color:#000000;">
              Lounge open hours: {{ item.product.opening_time }} - {{ item.product.closing_time }}
            </font>
          </td>
        </tr>
        <tr>
          <td>
            <font style="font-weight: normal; font-size: 14px; color:#000000;">
              Booking Reference: {{ item.booking.booking_ref }}
            </font>
          </td>
        </tr>
        <tr>
          <td>
            <font style="font-weight: normal; font-size: 14px; color: #000000;">
              <strong v-if="item.booking.booking_mode == 'Cancelled'">
                <font style="font-weight:bold;color:#FF0000;">
                  Status: {{ item.booking.booking_mode }}
                </font>
              </strong>
              <span v-else style="font-weight: bold; color: #00638c; font-size: 14px;">
                Status: {{ item.booking.booking_mode }}
              </span>
            </font>
          </td>
        </tr>
        <tr>
          <td height="5" style="line-height:5px; font-size:0px;">&nbsp;</td>
        </tr>
        <tr>
          <td>
            <font style="font-weight: normal; font-size: 14px; color:#000000;">
              Travel date: {{ item.booking.arrival_date_time }}
            </font>
          </td>
        </tr>
        <tr>
          <td height="5" style="line-height:5px; font-size:0px;">&nbsp;</td>
        </tr>
        <tr>
          <td>
            <font style="font-weight: bold; font-size: 16px; color:#000000;">
              Getting to {{ item.product.lounge_name }}
            </font>
          </td>
        </tr>
        <tr>
          <td height="5" style="line-height:5px; font-size:0px;">&nbsp;</td>
        </tr>
        <tr>
          <td>
            <font style="font-weight: normal; font-size: 14px; color:#000000;">
              <span v-html="item.product.location"></span>
              <br />
              <span v-html="item.product.directions"></span>
              <br />
              <span v-html="item.product.introduction"></span>
              <br />
            </font>
          </td>
        </tr>
        <tr v-if="item.product.important_information != ''">
          <td>
            <font style="font-weight: bold; font-size: 16px; color:#000000;">Important information</font>
          </td>
        </tr>
        <tr v-if="item.product.important_information != ''">
          <td height="5" style="line-height:5px; font-size:0px;">&nbsp;</td>
        </tr>
        <tr v-if="item.product.important_information != ''">
          <td>
            <font style="font-weight: normal; font-size: 14px; color:#000000;">
              <span v-if="item.product.important_information != ''" v-html="item.product.important_information" /><br />
              <span v-if="item.product.flightannouncements != ''" v-html="item.product.flightannouncements" /><br />
              <span v-if="item.product.dresscode != ''" v-html="item.product.dresscode" /><br />
              <span v-if="item.product.groups != ''" v-html="item.product.groups" /><br />
              <span v-if="item.product.childrenpermitted != ''" v-html="item.product.childrenpermitted" /><br />
              <span v-if="item.product.luggageleftonsite !=''" v-html="item.product.luggageleftonsite" /><br />
              <span v-if="item.product.facilitiesdisabled" v-html="item.product.facilitiesdisabled" /><br />
            </font>
          </td>
        </tr>
        <tr v-if="item.product.important_information != ''">
          <td height="5" style="line-height:5px; font-size:0px;">&nbsp;</td>
        </tr>
        <tr>
          <td>
            <font style="font-weight: bold; font-size: 16px; color:#000000;">
              Link to full Terms &amp; Conditions:
            </font>
          </td>
        </tr>
        <tr>
          <td>
            <font style="font-weight: normal; font-size: 14px; color:#000000;">
              <a href="/terms-and-conditions?utm_source=sps-confirmation&utm_medium=email&utm_campaign=confirmation-email">
                Terms and conditions
              </a>
            </font>
          </td>
        </tr>
      </table>
    </td>
  </tr>
</template>

<script>
import mixins from "@/mixins";

export default {
  name: "confirmation-view-lounge",
  mixins: [mixins.format],
  props: {
    item: { type: Object, default: () => {} },
    airportlounge: { type: Number, default: 1 }
  }
};
</script>